import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=6af30b64&scoped=true&"
import script from "./Loan.vue?vue&type=script&lang=js&"
export * from "./Loan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af30b64",
  null
  
)

export default component.exports